@if (!hideSection) {
    <div
        class="agpr-imageDisplay"
        [ngStyle]="{
            'text-align': data?.styles?.imageAlignment,
            'background-color': data?.styles?.backgroundColor,
            'padding-top': data?.styles?.padding.paddingOption
                ? (data?.styles?.padding.topPadding) + 'px'
                : (data?.styles?.padding.paddingAll) + 'px',
            'padding-right': data?.styles?.padding.paddingOption
                ? (data?.styles?.padding.rightPadding) + 'px'
                : (data?.styles?.padding.paddingAll) + 'px',
            'padding-bottom': data?.styles?.padding.paddingOption
                ? (data?.styles?.padding.bottomPadding) + 'px'
                : (data?.styles?.padding.paddingAll) + 'px',
            'padding-left': data?.styles?.padding.paddingOption
                ? (data?.styles?.padding.leftPadding) + 'px'
                : (data?.styles?.padding.paddingAll) + 'px'
        }"
    >
        @if (data?.imageProperties?.link) {
            <a
                [target]="data.imageProperties?.link?.openInNewWindow ? '_blank' : '_self'"
                [href]="data.imageProperties?.link?.url"
                class="agpr-imageDisplay-link"
                [ngStyle]="{
                    'width': displaySize+'%'
                }"
            >
                <ng-container
                    *ngTemplateOutlet="imageContainer"
                ></ng-container>
            </a>
        } @else {
            <div class="agpr-imageDisplay-link"
                [ngStyle]="{
                    'width': displaySize+'%'
                }"
            >
                <ng-container
                    *ngTemplateOutlet="imageContainer"
                ></ng-container>
            </div>
        }

        @if (data?.imageProperties?.caption) {
            <div
                class="agpr-imageDisplay-caption"
                [ngStyle]="{
                    'text-align': data?.styles?.alignment,
                    'font-weight': data?.styles?.bold ? 'bold' : 'normal',
                    'color': data?.styles?.color,
                    'font-family': data?.styles?.fontFamily,
                    'font-size': data?.styles?.fontSize,
                    'font-style': data?.styles?.italics ? 'italic' : 'normal',
                    'text-decoration': data?.styles?.underlined ? 'underline' : 'none',
                    'display': 'block',
                    'line-height': 'normal'
                }"
            >
                {{ data?.imageProperties?.caption }}
            </div>
        }

        @if (showAutomateIcon && !isPublished) {
            <div
                class="agpr-block-automated-tooltip"
                [agprTooltipCursor]="'Mention.editDialog.image.automate.info'"
                [escape]="false"
                tooltipPosition="right"
            >
                <div class="agpr-block-automated-tooltip-icon">
                    <span class="fa-kit fa-agpr-auto-block"></span>
                </div>
                <div class="agpr-block-automated-tooltip-line"></div>
            </div>
        }

    </div>

}

<ng-template #imageContainer>
    <!-- collage frame -->
    @if (data.imageEffects?.imageFrame === briefingImageFrame.COLLAGE) {
        <div
            class="agpr-imageDisplay-collage"
        >
            <div class="agpr-imageDisplay-collage-image agpr-imageDisplay-collage-image-topLeft">
                @if (data?.images?.[0]?.url && !data?.images?.[0]?.hasError) {
                    <img
                        [src]="data.images[0].url"
                        [alt]="data?.images?.[0]?.altText ? data?.images?.[0]?.altText : ''"
                        (error)="data.images[0].hasError = true"
                    />
                }

                @if (displayAutomateImagePlaceholder && data?.images?.[0]?.imageSource === imageSources.AUTOMATE) {
                    <ng-container
                        *ngTemplateOutlet="automateImagePlaceholder"
                    ></ng-container>
                }
            </div>
            <div class="agpr-imageDisplay-collage-image agpr-imageDisplay-collage-image-topRight">
                @if (data?.images?.[1]?.url && !data?.images?.[1]?.hasError) {
                    <img
                        [src]="data?.images?.[1]?.url"
                        [alt]="data?.images?.[1]?.altText ? data?.images?.[1]?.altText : ''"
                        (error)="data.images[1].hasError = true"
                    />
                }
                @if (displayAutomateImagePlaceholder && data?.images?.[1]?.imageSource === imageSources.AUTOMATE) {
                    <ng-container
                        *ngTemplateOutlet="automateImagePlaceholder"
                    ></ng-container>
                }
            </div>
            <div class="agpr-imageDisplay-collage-image agpr-imageDisplay-collage-image-bottomLeft">
                @if (data?.images?.[2]?.url && !data?.images?.[2]?.hasError) {
                    <img
                        [src]="data?.images?.[2]?.url"
                        [alt]="data?.images?.[2]?.altText ? data?.images?.[2]?.altText : ''"
                        (error)="data.images[2].hasError = true"
                    />
                }
                @if (displayAutomateImagePlaceholder && data?.images?.[2]?.imageSource === imageSources.AUTOMATE) {
                    <ng-container
                        *ngTemplateOutlet="automateImagePlaceholder"
                    ></ng-container>
                }
            </div>
            <div class="agpr-imageDisplay-collage-image agpr-imageDisplay-collage-image-bottomRight">
                @if (data?.images?.[3]?.url && !data?.images?.[3]?.hasError) {
                    <img
                        [src]="data?.images?.[3]?.url"
                        [alt]="data?.images?.[3]?.altText ? data?.images?.[3]?.altText : ''"
                        (error)="data.images[3].hasError = true"
                    />
                }
                @if (displayAutomateImagePlaceholder && data?.images?.[3]?.imageSource === imageSources.AUTOMATE) {
                    <ng-container
                        *ngTemplateOutlet="automateImagePlaceholder"
                    ></ng-container>
                }
            </div>
            <div class="agpr-imageDisplay-collage-blue agpr-imageDisplay-collage-blue-one"
                [ngStyle]="{
                    'background-color': data?.imageEffects?.primaryColor || accentColor
                }"
            ></div>
            <div class="agpr-imageDisplay-collage-blue agpr-imageDisplay-collage-blue-two"
                [ngStyle]="{
                    'background-color': data?.imageEffects?.primaryColor || accentColor
                }"
            ></div>
            <div class="agpr-imageDisplay-collage-blue agpr-imageDisplay-collage-blue-three"
                [ngStyle]="{
                    'background-color': data?.imageEffects?.primaryColor || accentColor
                }"
            ></div>
        </div>
    } @else {
        <!-- no frame WITH transition -->
        @if ((data?.images?.length > 1) && (data?.imageEffects?.transition)) {
            <div
                #slideshowContainer
                class="agpr-imageDisplay-slideshow-container"
            >
                @for (image of data?.images; track image.url) {
                    @if (image.url && !image.hasError) {
                        <div
                            [class]="'agpr-imageDisplay-fade ' + uniqueUUID + '_transitionImages'"
                            [ngClass]="{'agpr-imageDisplay-fade--active' : slideIndex === $index}"
                        >
                            <img
                                [style.maxWidth]="'100%'"
                                [src]="image.url"
                                [alt]="image?.altText ? image?.altText : ''"
                                (error)="image.hasError = true"
                                (load)="adjustSlideshowHeight()"
                                [ngStyle]="{
                                    'border-top-left-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                                        ? (data?.styles?.cornerRadius.topLeftCornerRadius) + 'px'
                                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                                    'border-top-right-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                                        ? (data?.styles?.cornerRadius.topRightCornerRadius) + 'px'
                                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                                    'border-bottom-left-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                                        ? (data?.styles?.cornerRadius.bottomLeftCornerRadius) + 'px'
                                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                                    'border-bottom-right-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                                        ? (data?.styles?.cornerRadius.bottomRightCornerRadius) + 'px'
                                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px'
                                }"
                            >
                        </div>
                    }
                    @if (displayAutomateImagePlaceholder && image.imageSource === imageSources.AUTOMATE) {
                        <div
                            [class]="'agpr-imageDisplay-fade ' + uniqueUUID + '_transitionImages'"
                            [ngClass]="{'agpr-imageDisplay-fade--active' : slideIndex === $index}"
                        >
                            <ng-container
                                *ngTemplateOutlet="automateImagePlaceholder"
                            ></ng-container>
                        </div>
                    }
                }
            </div>
        <!-- no frame WITHOUT transition -->
        } @else if (data?.images?.[0]?.url && !data.images?.[0]?.hasError) {
            <img
                class="agpr-imageDisplay-image"
                [src]="data?.images?.[0]?.url"
                [alt]="data?.images?.[0]?.altText ? data?.images?.[0]?.altText : ''"
                (error)="data.images[0].hasError = true"
                [ngStyle]="{
                    'border-top-left-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                        ? (data?.styles?.cornerRadius.topLeftCornerRadius) + 'px'
                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                    'border-top-right-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                        ? (data?.styles?.cornerRadius.topRightCornerRadius) + 'px'
                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                    'border-bottom-left-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                        ? (data?.styles?.cornerRadius.bottomLeftCornerRadius) + 'px'
                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                    'border-bottom-right-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                        ? (data?.styles?.cornerRadius.bottomRightCornerRadius) + 'px'
                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px'
                }"
            />
        } @else if(displayAutomateImagePlaceholder && data?.images?.[0]?.imageSource === imageSources.AUTOMATE) {
            <div
                class="agpr-imageDisplay-automate-placeholder"
                [ngStyle]="{
                    'border-top-left-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                        ? (data?.styles?.cornerRadius.topLeftCornerRadius) + 'px'
                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                    'border-top-right-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                        ? (data?.styles?.cornerRadius.topRightCornerRadius) + 'px'
                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                    'border-bottom-left-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                        ? (data?.styles?.cornerRadius.bottomLeftCornerRadius) + 'px'
                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                    'border-bottom-right-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                        ? (data?.styles?.cornerRadius.bottomRightCornerRadius) + 'px'
                        : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px'
                }"
            >
                <span class="fa-duotone fa-regular fa-image agpr-imageDisplay-automate-placeholder-icon"></span>
            </div>
        } @else if (showErrors) {
            <agpr-message [severity]="messageSeverityEnum.error" [useWhiteBg]="true">
                {{'Briefings.error.invalidImageUrl' | localize}}
            </agpr-message>
        }
    }
</ng-template>


<ng-template #automateImagePlaceholder>
    <div class="agpr-imageDisplay-automateImage-placeholder">
        <span class="fa-duotone fa-regular fa-image agpr-imageDisplay-automateImage-placeholder-icon"></span>
    </div>
</ng-template>

